export const IMAGES = {
    pavilionUmbrellas:
        "https://customer-assets-jt897jd0.emergentagent.net/job_b5f727d2-8e9e-4cee-9b52-9410e6da83bf/artifacts/2v2xwoxq_DSC05598.webp",
    pavilionTrees:
        "https://customer-assets-jt897jd0.emergentagent.net/job_b5f727d2-8e9e-4cee-9b52-9410e6da83bf/artifacts/bntivbuh_DSC05769.webp",
    gardenSeating:
        "https://customer-assets-jt897jd0.emergentagent.net/job_b5f727d2-8e9e-4cee-9b52-9410e6da83bf/artifacts/n3zm9hua_DSC05761.webp",
    esakDishMain: "/gallery/DSC09452.webp",
    esakDishSmall: "/gallery/DSC05786.webp",
};

export const CONTACT = {
    address: "Uncover Avenue, near Reliance Mall, Sector 13, Dwarka, Delhi 110078",
    phonePrimary: "+91 96540 40440",
    phoneSecondary: "+91 96540 40450",
    hours: "12:00 PM – 12:30 AM, every day",
    instagram: "https://www.instagram.com/uncoveravenue",
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=Uncover+Avenue+Sector+13+Dwarka+Delhi",
};

export const RESERVATION_URL =
    "https://reservations.petpooja.com/form/47f8afc7c227e437f80155f57f40ece897e13882e7fdda9f724cf59dd9e59f6aaf8d24625788e767a8e274649ea025fd65bf2a1ca56fd70ce7c934b362775d32ef2a80cf55fc5d550876032bfb1942f88126414e5416f66ae234fa2fc351523f";

export const ZOMATO_URL = "https://www.zomato.com/ncr/esak-sector-13-dwarka-new-delhi";

export const GOOGLE_URL =
    "https://www.google.com/maps/search/?api=1&query=Esak+Uncover+Avenue+Sector+13+Dwarka+Delhi";

export const ESAK_INSTAGRAM = "https://www.instagram.com/esak.delhi";
